import {
  Avatar,
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Popconfirm,
  Row,
  Table,
  Tooltip,
  Typography,
  Badge,
  message,
} from 'antd'
import {
  PlusOutlined,
  UserOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons'
import { useForm } from 'antd/es/form/Form'
import React, { useState } from 'react'
import { forwardRef } from 'react'
import { json } from 'react-router-dom'
import { useEffect } from 'react'
import { changeadministratior } from '../../../../api/api'
import './houseComment.css'
import CommentModal from './components/commentModal/commentModal'
import EditCommentModal from './components/editCommentModal/editCommentModal'
const HouseComment = forwardRef((props, ref) => {
  const [newCommentData, setNewCommentData] = useState(null)
  const [open, setOpen] = useState(false)

  const { setComment } = props
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode = <Input />
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: `请输入 ${title}!`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    )
  }
  const [form] = Form.useForm()
  const [data, setData] = useState(props?.data ?? null)
  const [count, setCount] = useState(0)
  const [editCommentData, setEditCommentData] = useState(null)
  const [editingKey, setEditingKey] = useState('')
  const [fresh, SetFresh] = useState(false)
  // const isEditing = (record) => {
  //   return record.key === editingKey
  // }

  useEffect(() => {
    console.log('fresh')
  }, [fresh])
  //按编辑后的调用
  const handleEdit = (newData, index) => {
    const newArr = data
    newArr[index] = newData
    console.log(newArr, 'newArr')
    setData([...newArr])
    setComment([...newArr])
    SetFresh((pre) => !pre)
  }

  useEffect(() => {
    console.log(data, 'data')
  }, [data])

  const cancel = () => {
    setEditingKey('')
  }

  //按保存时的调用
  const save = async (key) => {
    try {
      const row = await form.validateFields()
      const newData = [...data]
      const index = newData.findIndex((item) => key === item.key)
      if (index > -1) {
        const item = newData[index]
        newData.splice(index, 1, {
          ...item,
          ...row,
        })
        setData(newData)
        setEditingKey('')
      } else {
        newData.push(row)
        setData(newData)
        setEditingKey('')
      }
      // console.log(newData);
      setComment(() => {
        const data = newData.map((item, index) => {
          const newItem = {
            name: item.name,
            content: item.content,
          }
          return newItem
        })
        // console.log('new comment data', data)
        return data
      })
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo)
    }
  }

  //删除操作的调用
  const handleDelete = (target) => {
    const newData = data.filter((item, index) => index !== target)
    setData([...newData])
    setCount(count - 1)
    setComment([...newData])
  }

  //新增行的调用
  const handleAdd = (newData) => {
    // console.log("key is ",count);
    // console.log("content is ",JSON.stringify(newData));
    setData((pre) => [...pre, newData])
    setComment((pre) => [...pre, newData])
    // //让新增的行为可编辑状态
    // setEditingKey(count)
    // setCount(count + 1)
  }

  const columns = [
    {
      title: '租客',
      dataIndex: 'name',
      width: '15%',
      editable: true,
      // render:(text,record,index) => {
      //   console.log("render info",text,record,index);
      //   return (<h1>{record.name}</h1>)
      // }
    },
    {
      title: '头像',
      dataIndex: 'avatar',
      width: '6%',
      // editable: true,
      render: (text, record, index) => {
        // console.log('render info', text, record, index)
        return (
          <Avatar size="large" src={record.avatar} icon={<UserOutlined />} />
        )
      },
    },
    {
      title: '评价内容',
      dataIndex: 'content',
      width: '55%',
      editable: true,
      ellipsis: {
        showTitle: false,
      },
      render: (content) => (
        <Tooltip placement="topLeft" title={content}>
          {content}
        </Tooltip>
      ),
    },
    {
      title: '操作',
      dataIndex: 'operation',
      render: (_, record, index) => {
        // const editable = isEditing(record)
        return (
          <>
            <Row>
              <Col span={12}>
                <EditCommentModal
                  index={index}
                  handleEdit={handleEdit}
                  editCommentData={record}
                />
              </Col>
              <Col span={12}>
                <Popconfirm
                  title="确认删除?"
                  onConfirm={() => handleDelete(index)}
                >
                  <a>删除</a>
                </Popconfirm>
              </Col>
            </Row>
          </>
        )
      },
    },
  ]

  const mergedColumns = columns.map((col) => {
    // console.log("conl",col);
    if (!col.editable) {
      return col
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        // inputType: col.dataIndex === 'content' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        // editing: isEditing(record),
      }),
    }
  })

  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  }

  return (
    <>
      <Form form={form} component={false}>
        <Table
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          bordered
          dataSource={data}
          columns={mergedColumns}
          rowClassName="editable-row"
          pagination={false}
        />
        <CommentModal
          editCommentData={editCommentData}
          handleAdd={handleAdd}
          open={open}
          setOpen={setOpen}
        />
      </Form>
    </>
  )
})

export default HouseComment
